import { takeLatest, put, call } from 'redux-saga/effects';
import { SCORE_DEFINATION } from '../../../config'
import {
    GET_CREDIT_LIMIT_MODEL_DATA,
    UPDATE_CREDIT_LIMIT_MODEL_REQUEST,
    updateCreditLimitModelResponse,
    getCreditLimitModelDataSuccess
} from './action';
import { HTTP_HEADERS } from '../../../constants';
import request from "../../../components/Utils/httpHelper";


export function* getCreditLimitModelDataSaga(action) {
    let requestURL = `${SCORE_DEFINATION}/creditlimit/model/${action.data}`;
    try {
        const result = yield call(request, requestURL, { data: action.data, method: 'GET', headers: HTTP_HEADERS });
        yield put(getCreditLimitModelDataSuccess(result.data));
    } catch (err) {
        yield put(getCreditLimitModelDataSuccess(err))
    }
}
export function* editCreditLimitModelSaga() {
    yield takeLatest(GET_CREDIT_LIMIT_MODEL_DATA, getCreditLimitModelDataSaga);
}

export function* updateCreditLimitModel(action) {
    console.log(action)
    let requestURL = `${SCORE_DEFINATION}/creditlimit/update`;
    try {
        const createResult = yield call(request, requestURL, { method: 'PUT', data: action.data, headers: HTTP_HEADERS });
        yield put(updateCreditLimitModelResponse(createResult.data))
    }
    catch (err) {
        yield put(updateCreditLimitModelResponse(err))
    }
}

export function* updateCreditLimitModelSaga() {
    yield takeLatest(UPDATE_CREDIT_LIMIT_MODEL_REQUEST, updateCreditLimitModel);
}